'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.monthly_price_report', {
        template: '<monthly-price-report></monthly-price-report>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/price_report/monthly/monthly_price_report.routes.js